export default "__VITE_ASSET__5a64c05f__"